// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SnsTwitter from '../_raw/ui/icon_sns_twitter.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SnsTwitter);
